<template>
    <spinner-until :condition="participantLoaded">
        <participant-menu>
            <div class="my-habits">
                <b-row>
                    <b-col cols="12" lg="6" ref="my-habits">
                        <b-card no-body>
                            <b-card-header v-if="!showParticipantMenuAsAccordion">
                                <h5>
                                <span class="icon-wrapper icon-wrapper-left">
                                    <shs-icon name="clock"></shs-icon>
                                </span>
                                    {{ $i18n.gt('HEADING_MY_HABITS') }}
                                    <print-button content="my-habits" :refs="$refs"/>
                                </h5>
                            </b-card-header>

                            <div class="habits">
                                <div class="habits__entry"
                                     v-for="(h, index) in visibleHabits" :key="index">
                                    <!--  display habit, edit button, nudge status -->
                                    <div class="habits__alerts">
                                        <div class="habits__badge-archived pb-4"
                                             v-if="h.archivedTimestamp">
                                            <b-badge>
                                                {{ $i18n.gt('LABEL_HABIT_ARCHIVED') }}
                                            </b-badge>
                                        </div>
                                    </div>

                                    <div class="habits__content">

                                        <div class="habits__text">
                                            <b-row>
                                                <b-col>
                                                    <div class="habits__text__content">
                                                        {{ h.habit }}
                                                    </div>
                                                </b-col>
                                                <b-col cols="2" class="text-right">
                                                    <my-habits-edit-modal :habits="habits"
                                                                          :habit="h"
                                                                          :index="index">
                                                    </my-habits-edit-modal>
                                                </b-col>
                                            </b-row>
                                        </div>

                                        <div class="habits__graphs">
                                            <!-- motivation -->
                                            <my-habits-motivation :participant-id="participant.id"
                                                                  :habit="h"
                                                                  :index="index" class="habits__graph">
                                            </my-habits-motivation>

                                            <!-- progress -->
                                            <my-habits-progress :participant-id="participant.id"
                                                                :habit="h"
                                                                :index="index" class="habits__graph">
                                            </my-habits-progress>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <b-card-footer class="d-flex justify-content-between">

                                <div class="habits__archive-toggle">
                                    <b-form-checkbox switch
                                                     v-model="showArchived">
                                        {{ $i18n.gt('LABEL_SHOW_ARCHIVED_HABITS') }}
                                    </b-form-checkbox>
                                </div>

                                <div class="habits__add pull-right">
                                    <my-habits-edit-modal :habits="habits">
                                    </my-habits-edit-modal>
                                </div>

                            </b-card-footer>

                        </b-card>
                    </b-col>
                    <b-col cols="12" lg="6" ref="progress-notes">
                        <b-card no-body>
                            <b-card-header>
                                <h5>
                                    {{ $i18n.gt('HEADING_PROGRESS_NOTES') }}
                                    <print-button content="progress-notes" :refs="$refs"/>
                                </h5>
                            </b-card-header>
                            <b-card-body>
                                <survey-note-list :participantId="participant.id"
                                                  :for-patient="true">
                                </survey-note-list>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>

            </div>
        </participant-menu>
    </spinner-until>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>

import Vue from 'vue'
import * as _ from 'lodash'
import PatientPageMixin from '@/providers/PatientPageMixin'
import HabitFields from '@/models/Habit'

/**
 * Page to manage a Participant's wellness habits
 */
export default Vue.extend({
    name: 'MyHabits',
    mixins: [PatientPageMixin],
    data() {
        return {
            showArchived: false,
            selectedHabit: {
                habit: '',
                categories: [],
                reminder: false
            },
            habitFields: HabitFields,
            fieldGroups: [['habit', 'categories']],

            progressSliderValue: 5,
        }
    },
    computed: {
        habits() {
            return this.participant.wellness_plan.habits
        },
        visibleHabits() {
            return _.filter(this.habits, (habit) => {
                return this.showArchived || !habit.archivedTimestamp
            })
        }
    },
})
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">

@import '../../sass/base';

.my-habits {
    .graph-button {
        position: relative
    }
    .print-button {
        float: right;
        margin-top: .2em;
    }
}

.my-habit-motivation {
    margin-right: 10px;
}

.habits__entry {
    padding: 1em;
    border-bottom: solid 1px rgba(0, 0, 0, 0.125);

    &:last-child {
        border-bottom: none;
    }

    &:nth-child(odd) {
        background-color: var(--stripe-background);
    }

    .badge {
        display: block;
        max-width: 160px;
        margin: 0 auto !important;
    }
}

.habits__graphs {
    display: flex;
    justify-content: center;

}

.habits__graph {
    margin: 0 10px;
}

.habits__icon-reminder {
    svg use {
        fill: #888;
    }
}

.habits__text {
    margin-bottom: 1em;
    @media (max-width: $tablet-portrait) {
        line-height: 1.4;
    }
}

.habits__text__content {
    font-size: 1rem;
    position: relative;
    padding-right: 50px;
}

.habits__btn-edit {
    margin-left: 10px;
    position: absolute;
    right: 0;
    top: -2px;
}

.habits__alerts {
    text-align: center;
}

@media (min-width: 992px) and (max-width: 1439px) {
    .habits__text {
        font-size: 14px;
        line-height: 1.5;
    }
}

@media (min-width: 560px) and (max-width: 991px) {

    .habits__content {
        display: flex;
        justify-content: space-between;
    }

    .habits__text {
        padding-right: 1em;
    }
}

@media (min-width: 1430px) {
    .habits__content {
        display: flex;
        justify-content: space-between;
    }

    .habits__text {
        padding-right: 1em;
    }
}

</style>
